export default [
  {
    title: "Fulfillment",
    customIcon: 'FulfillmentSVG',
    children: [
      {
        title: "Fulfillment List",
        route: 'custom-fulfillment-list',
        path: '/custom-fulfillment/list',
      },
    ],
  },
]